export default {
  data() {
    return {
      linkedInternalDocuments: this.instruction?.linkedInternalDocuments || [],
    };
  },
  methods: {
    onLinkedInternalDocuments(documents) {
      this.linkedInternalDocuments = documents;
    },
  },
};
